/**
 * @flow
 */

import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { isBefore } from 'date-fns';
import { Calendar } from '../../../containers';

const intlMessages = defineMessages({
    placeholder: {
        id: 'report.DateRange.placeholder',
        defaultMessage: 'Date range',
    },
});

class DateRange extends Component {
    state: {
        from: ?Object,
        to: ?Object,
        enteredTo: ?Object,
    };

    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState() {
        const { fromDate, toDate } = this.props;
        return {
            from: fromDate,
            to: toDate,
            enteredTo: null,
        };
    }

    isSelectingFirstDay = (from, to, day) => {
        const isBeforeFirstDay = from && isBefore(day, from);
        const isRangeSelected = from && to;
        return !from || isBeforeFirstDay || isRangeSelected;
    };

    onDayClick = (day, closePopup) => {
        const { onChange } = this.props;
        const { from, to } = this.state;

        if (this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                from: day,
                to: null,
                enteredTo: null,
            });
        } else {
            this.setState({
                to: day,
                enteredTo: day,
            });

            if (onChange) {
                onChange(from, day);
            }
            if (closePopup) {
                closePopup();
            }
        }
    };

    onDayMouseEnter = day => {
        const { from, to } = this.state;
        if (!this.isSelectingFirstDay(from, to, day)) {
            this.setState({
                enteredTo: day,
            });
        }
    };

    handleResetClick = () => {
        this.setState(this.getInitialState());
    };

    render() {
        const { intl, workingDays } = this.props;
        const { from, to, enteredTo } = this.state;
        const modifiers = { workday: workingDays };

        return (
            <Calendar
                value={from && to ? [from, to] : ''}
                placeholder={intl.formatMessage(intlMessages.placeholder)}
                iconPosition="left"
                format="MMM d"
                dayPickerProps={{
                    numberOfMonths: 2,
                    modifiers,
                    disabled: this.props.disabledAfter ? { after: this.props.disabledAfter } : undefined,
                    selected: { from: from || undefined, to: enteredTo || to || undefined },
                    onDayMouseEnter: this.onDayMouseEnter,
                    onDayClick: this.onDayClick,
                    mode: 'range',
                }}
            />
        );
    }
}

export default injectIntl(DateRange);
